import React from "react";
import { Link } from "react-router-dom";

export const LifestyleSection = () => {
  return (
    <section className="py-20 md:py-32 bg-sand" data-testid="lifestyle-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
        <div className="space-y-6">
          <p className="b2t-overline">The B2T Lifestyle</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-navy leading-[1.05]">
            From the first cast<br />
            to the <span className="italic font-light text-seafoam-600">last putt.</span>
          </h2>
          <p className="text-navy/70 leading-relaxed text-base md:text-lg max-w-md">
            We build coastal lifestyle apparel for the people who chase tides and tee times. Performance fabrics. Tailored fits. Embroidered details. No fillers, no fluff — just gear that earns a place in your rotation.
          </p>
          <div className="grid grid-cols-3 gap-6 pt-4 max-w-md">
            <div>
              <div className="font-display text-3xl font-bold text-navy">UPF 50+</div>
              <div className="text-xs text-navy/50 uppercase tracking-widest mt-1">Sun-safe</div>
            </div>
            <div>
              <div className="font-display text-3xl font-bold text-navy">100%</div>
              <div className="text-xs text-navy/50 uppercase tracking-widest mt-1">Premium</div>
            </div>
            <div>
              <div className="font-display text-3xl font-bold text-navy">365</div>
              <div className="text-xs text-navy/50 uppercase tracking-widest mt-1">Coastal</div>
            </div>
          </div>
          <Link
            to="/about"
            data-testid="lifestyle-learn-more"
            className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.18em] text-navy border-b border-navy pb-1 hover:text-seafoam-600 hover:border-seafoam-600 transition-colors"
          >
            Our Story
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1758632535370-f5954a9686c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxmcmllbmRzJTIwb24lMjBib2F0JTIwd2VhcmluZyUyMHBvbG8lMjBzaGlydHN8ZW58MHx8fHwxNzgwMDE4MjI3fDA&ixlib=rb-4.1.0&q=85"
              alt="Friends on a boat"
              className="w-full h-[260px] md:h-[360px] object-cover"
              loading="lazy"
            />
          </div>
          <div className="overflow-hidden mt-12">
            <img
              src="https://images.pexels.com/photos/19793138/pexels-photo-19793138.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Seaside golf course"
              className="w-full h-[260px] md:h-[360px] object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
